'use client';

import { useProductInventory } from '../../cart/hooks/use-product-inventory';

export function useMaxQuantity({
  productGid,
  variantGid,
  allowBackorder,
}: {
  productGid: string | null;
  variantGid: string | null;
  allowBackorder: boolean;
}) {
  const { data: inventory } = useProductInventory(productGid);

  if (!productGid || !variantGid) {
    return 0;
  }

  const currentVariant = inventory?.variants?.edges?.find(
    (edge) => edge.node.id === variantGid
  )?.node;

  const maxQuantity = allowBackorder
    ? 99999999
    : currentVariant?.quantityAvailable;

  if (!maxQuantity) {
    return 0;
  }

  return maxQuantity;
}
